var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormatDoc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0H.5a.5.5 0 0 0-.5.5v23a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5v-17a.5.5 0 0 0-.146-.354l-6-6A.5.5 0 0 0 13.5 0Zm-.208.999 5.707 5.707v16.293h-18v-22h12.293Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0a.5.5 0 0 1 .492.41L14 .5l-.001 5.499L19.5 6a.5.5 0 0 1 .492.41L20 6.5a.5.5 0 0 1-.41.492L19.5 7h-6a.5.5 0 0 1-.492-.41L13 6.5v-6a.5.5 0 0 1 .5-.5ZM14.91 12.999c.986 0 1.564.605 1.786 1.634a.5.5 0 0 1-.978.21c-.131-.61-.355-.844-.808-.844-.56 0-.813.328-.886 1.275l-.018.339L14 16l.006.387.018.339c.073.946.325 1.274.886 1.274.453 0 .677-.235.808-.846a.5.5 0 1 1 .978.21c-.221 1.03-.8 1.636-1.786 1.636-1.451 0-1.91-1.002-1.91-3 0-1.999.459-3.001 1.91-3.001ZM10 13c-1.49 0-2 1.03-2 3 0 1.968.51 3 2 3 1.489 0 2-1.032 2-3 0-1.97-.51-3-2-3Zm0 1c.712 0 .976.467.998 1.803L11 16c0 1.486-.255 2-1 2-.746 0-1-.514-1-2 0-1.488.254-2 1-2ZM4.5 13h-1a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h1C5.954 19 7 17.69 7 16s-1.046-3-2.5-3Zm-.501 4.999v-4L4.5 14c.846 0 1.5.82 1.5 2 0 1.18-.654 2-1.5 2l-.501-.001Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormatDoc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/format-doc.df980d897db7954840b4f9dedf097c58.svg";